

export const IOS_LINK = 'https://apps.apple.com/be/app/wamp-competitions/id6444795864';
export const ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.wamp';
